<template>
  <div>
    <!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-app-bar
      id="badge_logoff"
      fixed
      app
      max-width="100%"
      class="mx-auto cmpbk_lght white--text dflex flex-row justify-space-between"
      absolute
      dense
    >
      <v-app-bar-nav-icon
        v-show="true"
        x-large
        @click="drawer = true"
      ></v-app-bar-nav-icon>
      <!-- <v-spacer></v-spacer> -->

      <v-img
        max-width="166"
        height="80%"
        width="auto"
        src="../images/badgesex150_40_3_white.png"
      ></v-img>
      <!-- <v-spacer></v-spacer> -->
      <div id="div_logoff">
        <v-btn icon text v-show="true" @click="toggle_logoff">
          <v-icon x-large>$person</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <div
      class="text-white"
      @click="logoff"
      style="
        z-index: 500;
        background-color: #363c43;
        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 50px;
        padding: 10px;
        border-radius: 4px;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>
    <!-- <div
      id="apptitle"
      style="max-width: 100% margin: auto; margin-top: 60px; background-color: #78806f !important; color: white !important"
      class="text-h5 elevation-2 text-center white font-weight-medium"
    >
      {{ app_title }}
    </div> -->
    <div
      id="app_name_bar"
      class="d-flex flex-row justify-center cmpbk_lght white--text"
      style="margin-top: 50px; width: 100%"
    >
      <div
        class="cmpbk_lght white--text text-h5 elevation-2 text-center d-flex flex-row justify-center font-weight-medium"
      >
        {{ app_title }}
      </div>
      <!-- <v-spacer></v-spacer> -->
    </div>

    <v-navigation-drawer
      id="v-navigation-drawer"
      height="100"
      v-model="drawer"
      absolute
      temporary
      color="cmpbk_lght"
    >
      <v-list
        nav
        dense
        close-on-click
        close-on-content-click
        class="cmpbk_lght white--text"
      >
        <v-list-item-group
          v-model="group"
          class="cmpbk_drk cmpbk_lght white--text"
          active-class="cmpbk_lght white--text"
          style="color: white"
        >
          <v-list-item style="color: white">
            <v-list-item-icon>
              <v-icon>$home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item style="color: white">
            <v-list-item-icon>
              <v-icon>$logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<style lang="scss" scoped>
/* 0 media q */
@media (min-width: 0px) {
  i.v-icon.v-icon {
    color: red;
  }

  .v-icon {
    color: #ffffff !important;
  }

  #badge_logoff {
    margin: 0 auto;
    width: 100%;
  }

  #badge_logoff:deep .v-toolbar__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<script>
export default {
  name: "brandbar",
  data: function () {
    return {
      showLogoff: false,
      user_email: "",
      app_title: "RPD NEWS",
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      }
    },
  },
  methods: {
    toggle_logoff() {
      this.showLogoff = !this.showLogoff;
    },
    logoff() {
      window.location.replace(
        "https://rpdlogin.org/rpdauth1/?returnURL=https://newsAdmin.renopd.com/"
      );
    },
  },
};
</script>
